<template>
  <div class="img__div--view" :src="src" :style="{width: width + 'px', height: height + 'px'}" v-if="src">
    <!-- <img v-lazy="src" :key="src" alt="图片" :style="{width: imgW, height: imgH}"> -->
    <el-image 
      :style="{width: imgW, height: imgH}"
      :src="src" 
      :preview-src-list="[src]" referrer-policy="no-referrer">
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline" style="font-size: 40px; color: #666;"></i>
      </div>
    </el-image>
  </div>
</template>

<script>
export default {
  name: "ImgView",
  props: {
    width: {
      type: Number|String,
      default: _=> 80
    },
    height: {
      type: Number|String,
      default: _=> 80
    },
    src: {
      type: String,
      default: _=> ''
    }
  },
  computed: {
    imgW: function () {
      // console.log('width', this.width)
      const _w = !!parseInt(this.width) ? parseInt(this.width) : 80
      return `${_w }px`
    },
    imgH: function () {
      // console.log('height', this.height)
      const _w = !!parseInt(this.height) ? parseInt(this.height) : 80
      return `${_w }px`
    }
  }
}
</script>

<style scoped>
.img__div--view {
  /* padding: 5px; */
  background: #ffffff;
  border-radius: 4px;
}
.img__div--view img {
  object-fit: contain;
}
</style>
<style>

.image-slot {
  height: 100%;
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    font-size: 40px;
  }
}
</style>